import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  IAutomationResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IAutomationResponseInstance'

export function mapAutomationResponseInstance(dashboard: IToJson<IAutomationResponseInstance>): IAutomationResponseInstance {
  return {
    ...dashboard,
  } as IAutomationResponseInstance // TODO: TS: Remove "as ..."
}
